
import { Organization } from '@/models/Organization';
import {Component, Vue} from 'vue-property-decorator';

interface RideitTab {
  label: string;
  routeName: string;
}

@Component({
  components: {
      
  }
})
export default class RideitPage extends Vue {

  pagination = {
    rowsPerPage: 10 // -1 for All,
  }

  organization: Organization = this.getOrganization();

  tabs: RideitTab[] = [
    {
      label: this.$t('rideIt.invitations', 'Kutsut'),
      routeName: 'RideitInvitations',
    },
    {
      label: this.$t('rideIt.changeRequests.title', 'Muutospyynnöt'),
      routeName: 'RideitChangeRequests',
    },
    // {
    //   label: this.$t('rideIt.passengers', 'Matkustajat'),
    //   routeName: 'RideitPassengers',
    // },
    // {
    //   label: this.$t('rideIt.users', 'Huoltajat'),
    //   routeName: 'RideitUsers',
    // }
    {
      label: this.$t('rideIt.communications', 'Viestintä'),
      routeName: 'RideitCommunications',
    }
  ];

  getOrganization() {
    const organizationId = this.$route.params.organizationId;
    return this.$store.state.organization.organizations.find((o: Organization) => o.id === organizationId);
  }

}
